import createEnum from 'scripts/lib/create_enum';
import createModel from '../lib/create_model';
import AttributeDef from './attribute_def';

const GenericTransactionDef = createModel({
  modelName: 'GenericTransactionDef',

  properties: {
    attributes: [AttributeDef],
  },
});

const FlightTransactionDef = createModel({
  modelName: 'FlightTransactionDef',

  properties: {
    attributes: [AttributeDef], // Optional attributes to be displayed generically
    statusCodeMap: Object, // Map from label to FlightStatusColor
    urlAttribute: String,
  },
});

const OrderTransactionDef = createModel({
  modelName: 'OrderTransactionDef',

  properties: {
    attributes: [AttributeDef],
  },
});

const StayTransactionDef = createModel({
  modelName: 'StayTransactionDef',

  properties: {
    attributes: [AttributeDef],
  },
});

const TransactionDefType = createEnum('FLIGHT', 'GENERIC', 'STAY', 'ORDER');

const TransactionDefClasses = Object.freeze([
  [TransactionDefType.FLIGHT, FlightTransactionDef],
  [TransactionDefType.GENERIC, GenericTransactionDef],
  [TransactionDefType.ORDER, OrderTransactionDef],
  [TransactionDefType.STAY, StayTransactionDef],
]);

const FlightStatusColor = createEnum('GREEN', 'YELLOW', 'RED');

export {
  GenericTransactionDef,
  FlightTransactionDef,
  FlightStatusColor,
  OrderTransactionDef,
  StayTransactionDef,
  TransactionDefClasses,
  TransactionDefType,
};



// WEBPACK FOOTER //
// ./src/scripts/domain/models/configuration/transaction_def.js